import { useTranslation } from 'react-i18next';

import {
  getManualActionURL,
  getVariableActionURL,
  ImageTypeBlock,
  isManualActionURL,
} from '../../../line-message-form';
import { LineMessageBlock } from '../shared';

export const LineMessagePreviewImages = ({ cards }: ImageTypeBlock) => {
  const { t } = useTranslation('crm');

  return (
    <LineMessageBlock.Container title={t('crm.lineMessagePreview.imageType.title')}>
      {cards.map(({ image, actionUrl, actionLabel }, index) => {
        const manualUrl = getManualActionURL(actionUrl);
        const variableUrl = getVariableActionURL(actionUrl);
        const url = isManualActionURL(actionUrl) ? manualUrl : variableUrl;

        return (
          <li className="crm-line-message-preview__list-item" key={`image-type-${index}`}>
            <LineMessageBlock.Image imageUrl={image?.src ?? ''} label={actionLabel ?? ''} />
            <LineMessageBlock.UrlPreview url={url} />
          </li>
        );
      })}
    </LineMessageBlock.Container>
  );
};
